import React from 'react';
import background from '../../assets/Tumbleweed_bg.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoTumbleweed extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="LAND"
        description="Tumbleweed"
        paragraph="Warming sea surface temperatures are forcing populations of the American lobster (Homarus americanus) to higher latitudes than ever before—and upending fishing communities on the New England coast."
        background={background}
     />
  
  );
 }
}   

export default InfoTumbleweed;